import css from '../taskDescription.module.css'
import preview from './nineTypeTask.jpg'
import taskDescriptionTexts from '../taskDescriptionTexts'

const EightsTypeTaskDescription = () => {
  return (
    <div className={css.wrapper}>
      <div className={css.image} style={{ backgroundImage: `url("${preview}")` }}>
        <div className={css.imageTaskTypeNumber}>
          <p style={{ fontSize: '24px', color: '#976153' }}>10</p>
        </div>
      </div>
      <p className={css.description}>{taskDescriptionTexts[9]}</p>
    </div>
  )
}

export default EightsTypeTaskDescription
